import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import FormHelperText from '@material-ui/core/FormHelperText';
import { getHelpOrError, hasError } from './_common';

const StarsRating = ({ onChange, value, name, style, required, errors, label, help, scores }) => {
  const theme = useTheme();
  const error = hasError(errors, name);

  return (
    <FormControl fullWidth margin="none" style={{ marginTop: '8px', ...style }} required={required}>
      <Typography variant="body2" color={error ? 'error' : 'initial'}>
        {label}
      </Typography>
      <div>
        {scores.map((score) => (
          <IconButton
            key={score}
            onClick={() => {
              onChange(score);
            }}
            style={{ margin: -theme.spacing(1) }}
          >
            {!value || value < score ? (
              <StarBorder color={error ? 'error' : 'primary'} />
            ) : (
              <Star color={error ? 'error' : 'primary'} />
            )}
          </IconButton>
        ))}
      </div>
      <FormHelperText error={error}>
        <span>{getHelpOrError(help, errors, name)}</span>
      </FormHelperText>
    </FormControl>
  );
};

StarsRating.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.shape({}),
  help: PropTypes.string,
  scores: PropTypes.arrayOf(PropTypes.number),
  style: PropTypes.shape({}),
  label: PropTypes.node,
};

export default StarsRating;
